import {AxiosResponse, AxiosError} from 'axios';
import {Link, useNavigate} from 'react-router-dom';
import React, {useState, useEffect} from 'react';
import {updateCartItem} from '../../utils/axiosCalls';
import {formatervalue, formatString, getTotalByItens, groupCartData, TokensEnum} from '../../utils';
import deleteIcon from "../../assets/images/icons/delete-icon.svg";
import "./MyRequest.scss"
import {ApiService2} from "../../services/api";
import {useCart} from "../../hooks/useCart";
import useAuth from "../../hooks/useAuth";
import {ToastError} from "../../services/toast-service";
import {ROUTES} from "../../index";
import { Deserializer } from 'jsonapi-serializer';

import './../ProductsPage/ProductsPage.scss'
import {ICart, IItem, IITemCart} from "../../utils/interfaces";

const MyRequest = () => {

    useAuth({})
    const authorization = localStorage.getItem(TokensEnum.KEY_TOKEN)

    const navigate = useNavigate();
    const {setCartItems, cartItems, setOrdersToModal, setModalOpen} = useCart()
    const [cartItem, setCartItem] = useState([] as IITemCart[])
    const [cart, setCart]: [cart: any, setCart: Function] = useState()
    const [cartId, setCartId] = useState("")
    const [total, setTotal] = useState(0)

    const getShoppingCartPromisse2 = async () => {
        return await ApiService2.get("carts")
            .then((res: AxiosResponse) => {
                new Deserializer({}).deserialize(res.data, function (err: any, cart: any) {
                    const myCart: any= cart
                    setCartItem(groupCartData(myCart["cart-items"]) as any)
                    setCartId(cart.id)
                })
            })
            .catch((error: AxiosError) => {
                console.log(error.response!)
            })
    }

    useEffect(() => {
        getShoppingCartPromisse2()
    }, [])

    useEffect(() => {
        calculateTotal()
    }, [cartItems])

    useEffect(() => {
        calculateTotal()
    }, [cartItems])


    const clickHandlerDeleteItem = (saleId: number | string, cartId: number | string) => {
        deleteCartItem(saleId, cartId)
    }

    function StatusComponent({ status }: any) {
        let statusClass;

        if (status === 'Pending') {
            statusClass = 'status-pending';
        } else if (status === 'Canceled') {
            statusClass = 'status-canceled';
        } else if (status === 'Completed') {
            statusClass = 'status-completed';
        } else {
            statusClass = 'status-default';
        }

        return (
            <div className={statusClass}>
                <p>{status}</p>
            </div>
        );
    }


    const deleteCartItem = (cartId: number | string, saleId: number | string) => {
        try {
            ApiService2
                .delete(`carts/${cartId}/cart_items/${saleId}`, {
                    headers: {
                        'Authorization': authorization
                    }
                })
                .then((res: AxiosResponse) => {
                    getShoppingCartPromisse2()
                })
                .catch((error: any) => {
                    ToastError(error?.response?.data?.message || error.message)
                })
        } catch (e: any) {
            ToastError(e?.response?.data?.message || e.message)
        }
    }

    const calculateTotal = () => {
        const result = cartItems.reduce((accumulator: any, current: any) => {
            return (current.sale?.product?.price * current.quantity) + accumulator
        }, 0)
        setTotal(result)
    }

    const clickHandler: Function = async (saleId: number | string, productId: any, quantity: number) => {
        try {
            await updateCartItem(cartId, productId, saleId, quantity)
            await getShoppingCartPromisse2()
        } catch (e: any) {
            ToastError(e?.response?.data?.message || e.message)
        }
    }

    const sendOrder = async () => {
        try {
            const result = await ApiService2.post(`customers/orders`)
            setOrdersToModal(result?.data?.data)
            setModalOpen(true)
            getShoppingCartPromisse2()
        } catch (e: any) {
            console.log(e?.response?.data?.message || e.message)
            ToastError(e?.response?.data?.message || e.message)
        }
    }

    return (
        <div className='MyCart'>
            <div className="product-page-wrapper">

                <div className="breadcrumb-main-area">
                    <div className="container-fluid">
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-md-6">
                                    <div className="breadcrumb-left">
                                        <nav>
                                            <ol className="breadcrumb">
                                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                                <li className="breadcrumb-item active" aria-current="page">
                                                    Meu Pedido
                                                </li>
                                            </ol>
                                        </nav>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="cart-wrapper-main">
                    <div className="container-fluid">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="cart-main-area">
                                        <div className="row">
                                            <div className="col-lg-8 col-md-12">
                                                <div className="cart-item-area d-flex justify-content-between">
                                                    <h2>
                                                        Meu Pedido
                                                    </h2>
                                                    <div className='text-dark mr-2'>
                                                        <StatusComponent status={''}/>
                                                    </div>
                                                </div>
                                                {cartItem?.map((mycart: IITemCart, key: number) => {
                                                    console.log(mycart)
                                                    return <div className="cart-item-area" key={key}>
                                                        <h2 className='mt-4'>
                                                            {mycart.supplierName || `Sem nome(${key + 1})`}
                                                        </h2>
                                                        <div className="cart-items-main">
                                                            {mycart?.items?.map((product: IItem, key: number) => {
                                                                return <div className="cart-item my-4" key={key}>
                                                                    <div className="cart-image ">
                                                                        <img
                                                                            src={product?.sale?.product?.images[0]?.image}
                                                                            alt="Product"/>
                                                                    </div>
                                                                    <div className="cart-title mx-4">
                                                                        <span className={'cursor-pointer'} onClick={() => navigate(`${ROUTES.PRODUCTS}/${product?.sale?.product.id}`)}>{product?.sale?.product?.name}</span>
                                                                        <p className='cart__p'><small>Tipo de unidade: {product?.sale?.product.unit}</small></p>
                                                                        <p className='cart__p'><small>Valor unitario: R${formatervalue(product.sale.price)}</small></p>
                                                                        <p className='cart__p'><small>Quantidade: {product.quantity}</small></p>
                                                                    </div>
                                                                    <div className="quantity-box">
                                                                    </div>
                                                                    <div className="cart-price">
                                                                        R${(formatervalue(((product?.sale?.price || 0) * product?.quantity)))}
                                                                    </div>
                                                                </div>
                                                            })}
                                                        </div>
                                                    </div>
                                                })
                                                }
                                            </div>
                                            <div className="col-lg-4 col-md-12">
                                                <div className="cart-summary-area">
                                                    <h2>Resumo</h2>
                                                    <div className="cart-summary-main">

                                                        {cartItem?.map((cart: any, key: number) => {
                                                            return <div className="cart-summary-item">
                                                                <div className='mt-4 text-dark'>
                                                                    {cart.supplierName || `Sem nome(${key + 1})`}
                                                                </div>
                                                                <p>R$ {formatervalue(getTotalByItens(cart?.items) || 0)}</p>
                                                            </div>
                                                        })
                                                        }
                                                        <div className="total-amount">
                                                            <h2>Total </h2>
                                                            <h2>
                                                                {formatervalue(cartItem.reduce((previousValue: number, currentValue: any) => {
                                                                    return getTotalByItens(currentValue.items) + previousValue
                                                                }, 0))}
                                                            </h2>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default MyRequest;
